var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23391_30824)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23391_30824",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.619 -2.59355e-08L2.38095 -2.73006e-09C1.06599 -1.22229e-09 -1.36314e-09 1.07452 -3.04465e-09 2.4L-1.97902e-08 15.6C-2.14717e-08 16.9255 1.06599 18 2.38095 18L22.619 18C23.934 18 25 16.9255 25 15.6L25 2.4C25 1.07452 23.934 -2.74433e-08 22.619 -2.59355e-08Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23391_30824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.619 -2.59355e-08L2.38095 -2.73006e-09C1.06599 -1.22229e-09 -1.36314e-09 1.07452 -3.04465e-09 2.4L-1.97902e-08 15.6C-2.14717e-08 16.9255 1.06599 18 2.38095 18L22.619 18C23.934 18 25 16.9255 25 15.6L25 2.4C25 1.07452 23.934 -2.74433e-08 22.619 -2.59355e-08Z",
    fill: "#0034A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12L25 12L25 18L-7.61162e-09 18L0 12Z",
    fill: "#D7280F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L25 -2.86656e-08L25 6L-7.61162e-09 6L0 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.619 0.599976L2.38093 0.599976C1.39471 0.599976 0.595215 1.40586 0.595215 2.39998L0.595215 15.6C0.595215 16.5941 1.39471 17.4 2.38093 17.4L22.619 17.4C23.6052 17.4 24.4047 16.5941 24.4047 15.6L24.4047 2.39998C24.4047 1.40586 23.6052 0.599976 22.619 0.599976Z",
    stroke: "black",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23391_30824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/RU.a3fe8e64f5db11cd76d884ac75ae0acd.svg";
export { ForwardRef as ReactComponent };